import { Tooltip } from "@mui/material";
import AlertTriangle from "assets/img/svg/alertTriangle";
import { useTranslation } from "react-i18next";

/**
 * Render wrong payment info icon + tooltip
 */
const WrongPaymentInfo = () => {
    const [t] = useTranslation();
    return (
        <Tooltip title={t("Payment.WrongBankInfo")} arrow>
            <div style={{ height: "15px" }}>
                <AlertTriangle />
            </div>
        </Tooltip>
    );
};

export default WrongPaymentInfo;
